import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AlertsService } from '../../services/alerts.service';
import { NgbAlertConfig } from '@ng-bootstrap/ng-bootstrap';
import { AlertModel, AlertType } from '../../models/alert.model';
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'app-alerts',
	templateUrl: './alerts.component.html',
	styleUrls: ['./alerts.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertsComponent implements OnInit {
	alerts: Array<AlertModel> = [];

	constructor(private alertsService: AlertsService, private alertConfig: NgbAlertConfig, private ref: ChangeDetectorRef) {
		alertConfig.dismissible = true;
		alertConfig.type = 'danger';
	}

	ngOnInit() {
		this.alertsService.alert$.subscribe(alert => {
			if (!alert) {
				// clear alerts when an empty alert is received
				this.alerts = [];
			} else {
				const dato = this.alerts.find(resultado => {
					return (resultado.alertId === alert.alertId && resultado.url === alert.url);
				});
				if (!dato) {
					// add alert to array
					this.alerts.push(alert);
				}
			}

			this.ref.detectChanges();
		});
		this.alertsService.alert$.pipe(
			debounceTime(10000)
		).subscribe(() => {
			this.removeAlertIndex(0);
			this.ref.detectChanges();
		});
	}

	removeAlert(alert: AlertModel) {
		this.alerts = this.alerts.filter(x => x !== alert);
		this.ref.detectChanges();
	}

	removeAlertIndex(index: number) {
		if (this.alerts && this.alerts.length > index) {
			// this.alerts.splice(index, 1);
			this.alerts = [];
		}
	}
}